import router from '@/router';

// 用户信息

export default {
  namespaced: true, // 开启命名空间
  state: () => {
    return {
      profile: {
        token: '',
        currentChain: {  // 当前链
          chainId: '',
          chainName: ''
        },
        currentGroup: {
          netId: "",
          groupId: "",  // 群组id
          groupName: "",  // 群组名称
        }
      }
    }
  },
  actions: {
    setUser: ({ state, dispatch }, data) => {

      return new Promise(async resolve => {

        // 拼接对象
        if (data == 'clear') {
          // 清空
          state.profile = {}



          // 清除多签页缓存
          await dispatch('admin/page/closeAll', null, { root: true })


          // 跳转路由
          router.replace('/login')
        } else {
          Object.assign(state.profile, data)
        }

      })

    }
  }

}
